export default __webpack_public_path__ + "static/16-8f21cb00504dce6a214204b087849f0b.webp";